
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hospitals/influenza",
      function () {
        return require("private-next-pages/hospitals/influenza/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hospitals/influenza"])
      });
    }
  